if( !window.hktng_cart ) {
  window.hktng_cart = {}
  var x = window.hktng_cart
  x.cart_footer_section_id = null;
  x.cart_footer_html_element = null;
  x.cart_items_html_element = null;
  x.cart_drawer_section_id = null;
  x.cart_drawer_html_element = null;
  x.cart_drawer_items_html_element = null;
  x.xml = new XMLHttpRequest();
  x.init = function() {
    console.debug( "hktng_cart: INIT: " , this  )
    this.find_cart_footer();
    this.find_cart_items();
    if( this.cart_items_html_element ) {
      this.cart_items_html_element.addEventListener( "submit" , (event) => {   console.debug( "cart: EVENT: submit: " , this , event ); this.event_cart_items_submit( event , this ) } )
    }

    if( PUB_SUB_EVENTS && subscribe ) {
      subscribe( PUB_SUB_EVENTS.cartUpdate ,     x.event_cart_update )
      subscribe( PUB_SUB_EVENTS.quantityUpdate , x.event_cart_update )
    }

      
  }
  x.find_cart_items = function() {
    this.cart_items_html_element = document.querySelector("form#cart")
  }
  x.find_cart_footer = function() {
    this.cart_footer_html_element = document.getElementById('main-cart-footer')
    if( this.cart_footer_html_element ) {
      this.cart_footer_section_id = document.getElementById('main-cart-footer').dataset.id
    } else {
      this.cart_footer_section_id = null
    }
  }
  x.update_cart_footer = function() {
    if( this.cart_footer_html_element ) {
      const r = new XMLHttpRequest();
      this.xml = r;
      r.open( 'GET' , '/?section_id=' + this.cart_footer_section_id , true );
      r.addEventListener( "loadend" , (event) => { this.update_cart_footer_result( event , this ) } )
      r.send();
    }
  }
  x.update_cart_footer_result = function( event , x ) {
    if( x && x.cart_footer_html_element ) {
//      console.debug( x.xml.response )
      if( x.xml.response.length > 100 ) {
        const n = document.createElement('div')
        n.innerHTML = x.xml.response
        x.cart_footer_html_element.innerHTML = n.firstChild.innerHTML
      }
    }
  }
  
  x.event_cart_items_submit = function( event , x ) {
    // console.debug( "cart: EVENT: submit: " , x , event )
    if( x && x.cart_footer_html_element ) {
    }
  }

  x.event_cart_update = function( ev ) {
    console.debug( "cart: EVENT" , ev )
    x.update_cart_footer.call(x)
  }
}

if( window.hktng_cart ) {
  window.hktng_cart.init();
}
